import { DASHBOARD, LOGIN } from '_constants';

export const dashboard = (state = {}, action) => {
  let newState = { ...state };
  switch (action.type) {
    case DASHBOARD.ANIMATE_COUNTER:
      newState.scoreCount = action.value;
      break;
    case DASHBOARD.FETCH_DASHBOARD_DATA:
      newState.sqSize = 250;
      newState.scoreCount = 1;
      newState.strokeWidth = 10;
      newState.percentage = 100;
      newState.radius = (newState.sqSize - newState.strokeWidth) / 2;
      newState.viewBox = `0 0  ${newState.sqSize} ${newState.sqSize}`;
      newState.dashArray = newState.radius * Math.PI * 2;
      newState.dashOffset = newState.dashArray - newState.dashArray * newState.percentage / 100;
      break;
    case DASHBOARD.UPDATE_OPPORTUNITIES:
      newState.opportunities = action.value.opportunities;
      break;
    case LOGIN.LOGOUT:
      newState = {};
      break;
    default:
      break;
  }
  return newState;
};
